import { TelemetryInitializerFunction } from '@microsoft/applicationinsights-core-js';

export const healthChecksFilter: TelemetryInitializerFunction = envelope => {
  if (envelope!.baseData!.target && envelope!.baseData!.target.endsWith('/health')) {
    return false;
  }

  return true;
};
